import React, { useState } from "react";
import { updateLocation } from "services/locationService";
import { useNavigate } from "react-router-dom";
import * as Sentry from "@sentry/react";

const LocationForm = ({ location, onSuccess }) => {
  const [name, setName] = useState(location?.name || "");
  const [table, setTable] = useState(location?.table || "");
  const [facebook, setFacebook] = useState(location?.facebook || "");
  const [usesRankings, setUsesRankings] = useState(location?.usesRankings || false);
  const [displayRanking, setDisplayRanking] = useState(location?.displayRanking || false);
  const [allowMyMatches, setAllowMyMatches] = useState(location?.allowMyMatches || false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await updateLocation(location.id, {
        name,
        table,
        facebook,
        usesRankings,
        displayRanking,
        allowMyMatches,
      });
      onSuccess();
    } catch (err) {
      Sentry.captureException(err);
      console.error("Error updating location:", err);
      setError("Une erreur est survenue lors de la sauvegarde.");
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="bg-slate-900 border border-slate-700 p-6 rounded-lg shadow-xl max-w-xl mx-auto text-slate-50 space-y-6"
    >
      <h2 className="text-2xl font-bold text-center">Modifier le lieu</h2>

      {error && <p className="text-red-400 font-medium text-center">{error}</p>}

      <div>
        <label className="block mb-1 font-medium">Nom:</label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          className="w-full px-4 py-2 rounded bg-slate-800 border border-slate-700 focus:outline-none focus:ring focus:border-amber-400"
        />
      </div>

      <div>
        <label className="block mb-1 font-medium">Table:</label>
        <input
          type="text"
          value={table}
          onChange={(e) => setTable(e.target.value)}
          className="w-full px-4 py-2 rounded bg-slate-800 border border-slate-700 focus:outline-none focus:ring focus:border-amber-400"
        />
      </div>

      <div>
        <label className="block mb-1 font-medium">Page Facebook:</label>
        <input
          type="url"
          value={facebook}
          onChange={(e) => setFacebook(e.target.value)}
          placeholder="https://facebook.com/..."
          className="w-full px-4 py-2 rounded bg-slate-800 border border-slate-700 focus:outline-none focus:ring focus:border-amber-400"
        />
      </div>

      <div className="flex items-center space-x-3">
        <label className="text-lg font-medium">Utilise les classements:</label>
        <input
          type="checkbox"
          checked={usesRankings}
          onChange={(e) => setUsesRankings(e.target.checked)}
          className="form-checkbox h-5 w-5 text-green-500"
        />
      </div>

      <div className="flex items-center space-x-3">
        <label className="text-lg font-medium">Afficher les classements:</label>
        <input
          type="checkbox"
          checked={displayRanking}
          onChange={(e) => setDisplayRanking(e.target.checked)}
          className="form-checkbox h-5 w-5 text-green-500"
        />
      </div>

      <div>
        <div className="flex items-center space-x-3">
          <label className="text-lg font-medium">Permettre "Mes matchs":</label>
          <input
            type="checkbox"
            checked={allowMyMatches}
            onChange={(e) => setAllowMyMatches(e.target.checked)}
            className="form-checkbox h-5 w-5 text-green-500"
          />
        </div>
        <p className="text-sm text-slate-400 mt-1">
          Permet aux joueurs de consulter et entrer les scores de leurs propres matchs.
        </p>
      </div>

      <div className="flex justify-between flex-wrap gap-4">
        <button
          type="submit"
          className="bg-amber-500 hover:bg-amber-600 text-white px-6 py-2 rounded-md font-semibold transition"
        >
          Mettre à jour
        </button>

        <button
          type="button"
          onClick={() => navigate(-1)}
          className="bg-slate-700 hover:bg-slate-600 text-white px-6 py-2 rounded-md font-semibold transition"
        >
          Annuler
        </button>
      </div>
    </form>
  );
};

export default LocationForm;
